import * as Yup from 'yup';

import { missionCategorySchemaFields } from '../../../components/MissionCategoryAutocomplete/schemas/mission-category.schema';

export const MissionGeneralInfoSchema = Yup.object().shape(
  missionCategorySchemaFields,
);

export const CollaborationGeneralInfoSchema = Yup.object().shape({});
